import { render, staticRenderFns } from "./SithMesInventoryMaterialDispatchingEdit.vue?vue&type=template&id=fb356bb8&"
import script from "./SithMesInventoryMaterialDispatchingEdit.vue?vue&type=script&lang=js&"
export * from "./SithMesInventoryMaterialDispatchingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports